import { getBackendErrorMessage } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import type { ShowToastOptions } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.types';

interface FailedToast extends Pick<ShowToastOptions, 'title' | 'message'> {
	error?: unknown;
}

export interface ActionToasts {
	succeeded: (title: string) => void;
	failed: (options?: FailedToast) => void;
}

export const useActionToasts = (): ActionToasts => {
	const tCapManage = useTranslationCapManage();
	return {
		succeeded: (title) => showToastV2({ title }),
		failed: ({ title, message, error } = {}) => {
			const line = message ?? getBackendErrorMessage(error);
			showToastV2({
				title: title ?? tCapManage('dealstack_ai.transactions.toast.action_failed'),
				...(line === undefined ? {} : { message: line }),
				state: 'error',
			});
		},
	};
};
